interface ConfigurationCustomerResponse {
  Code: string;
  PropertySubdomain: string | null;
  DisplayName: string | null;
}

interface ConfigurationFeaturesResponse {
  Loyalty: boolean;
  Venues: boolean;
  Preferences: boolean;
  Rfm: boolean;
  KatakanaKanjiName: boolean;
  ProfileDosAndDonts: boolean;
  ProfileFreeTextPreference: boolean;
  HideDateOfBirth?: boolean;
}

interface ConfigurationUiConfigResponse {
  PersonIdLabel?: string;
  RfmTier?: string;
}

export enum ServiceUrlKey {
  StaffApiBaseUrl = 'StaffApiBaseUrl',
  CoreApiBaseUrl = 'CoreApiBaseUrl',
  IdpBaseUrl = 'IdpBaseUrl',
  FactsBaseUrl = 'FactsBaseUrl',
  LookUpBaseUrl = 'LookUpBaseUrl',
  VenuesBaseUrl = 'VenuesBaseUrl',
}

export interface ConfigurationServicesResponse {
  StaffApiBaseUrl: string;
  CoreApiBaseUrl: string;
  IdpBaseUrl: string;
  FactsBaseUrl: string;
  LookUpBaseUrl: string;
  VenuesBaseUrl: string;
}

export interface ConfigurationApiResponse {
  Version: number;
  Customer: ConfigurationCustomerResponse;
  Features: ConfigurationFeaturesResponse;
  UiConfig: ConfigurationUiConfigResponse;
  Services: ConfigurationServicesResponse;
  DateFormat?: string;
}
